import {css} from 'lit'; export default css`.canvas-connection svg{top:0;left:0;position:absolute;overflow:visible}`;
    